<template>
  <div id="asesoria">
    <div class="section ligth">
      <div class="container fadeInUp wow" data-wow-duration="0.5s">
        <h3>Gerenciamiento de Proyectos</h3>
        <div class="line bg-primary mb-5"></div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <img
              class="img-fluid w-100"
              src="../assets/product/gerencia.jpg"
              alt="Administración"
            />
          </div>
          <div class="col-md-6 mb-4 d-none d-md-block">
            <img
              class="img-fluid w-100"
              src="../assets/product/gerencia1.jpg"
              alt="Administración"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            Nuestro Gerenciamiento de Proyectos va desde el Estudio de
              Prefactibilidad hasta su puesta en marcha según requiera nuestro
              Mandante. Esto incluye el desarrollo de las especialidades de
              Climatización, ventilación, calefacción, CCTV, Control de Accesos,
              Proyecto Sanitario, Proyecto de pavimentación y aguas lluvias.<br><br>
              El Gerenciamiento se inicia con el proceso de selección de los
              proyectistas de arquitectura, cálculo y especialidades, aprobación
              de permisos de Edificación, licitación de Construcción y
              seguimiento de Construcción.
          </div>
          <div class="col-md-6 mb-4">
            Interactuamos con las diversas especialidades y la Inspección
              Técnica que defina el Mandante. Nuestro Gerenciamiento de Proyecto tiene los siguientes alcances
              de diseño:
            <ul class="mt-3">
              <li>Proceso de diseño, desarrollo de arquitectura e ingeniería
                estructural.</li>
              <li>Plan de Gestión de Interesados (Stakeholders).</li>
              <li>Plan de Adquisiciones del proyecto.</li>
              <li>Plan de Gestión de Riesgos del proyecto.</li>
              <li>Plan de Gestión de las comunicaciones.</li>
              <li>Plan de calidad.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Asesoria",
};
</script>
